import { chakraComponents, GroupBase, InputProps } from 'chakra-react-select';
import clsx from 'clsx';

export const Input = <Option extends {}>(
  props: InputProps<Option, false, GroupBase<Option>>
) => {
  const { selectProps, inputClassName } = props;
  const { label, placeholder, dataTestId } = selectProps;
  return (
    <chakraComponents.Input
      {...props}
      inputClassName={clsx(inputClassName, {
        hasLabel: !!label,
      })}
      isHidden={false}
      data-testid={dataTestId || label || placeholder}
    />
  );
};
